import { shadows as coreShadows } from '../core';

/**
 * https://mui.com/material-ui/customization/default-theme/?expand-path=$.shadows
 */
const shadows = [coreShadows.popover];

export default shadows;
